import { render, staticRenderFns } from "./WebsiteDetailsModal.vue?vue&type=template&id=37a94e78"
import script from "./WebsiteDetailsModal.vue?vue&type=script&lang=js"
export * from "./WebsiteDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports